import InfiniteScroll from "infinite-scroll";

export const autoLoad = function (el) {
    const containerSelector = el.getAttribute("data-container-selector");
    const selector = el.querySelector(containerSelector);
    let infScroll = new InfiniteScroll(selector, {
        path: ".pagination a",
        append: ".autoloadable-item",
        history: "push",
        hideNav: ".pagination",
    });

    infScroll.on("load", function (body, path, response) {
        selector
            .querySelectorAll(".autoloadable-item--ghost")
            .forEach(function (item) {
                item.remove();
            });
    });
    infScroll.on("append", function (body, path, items, response) {
        items.forEach(function (item, i) {
            setTimeout(function () {
                item.classList.add("loaded");
            }, 250 + i * 50);
        });
    });
};
